import { getConstants } from "@utilifiles/methods/storage/storage";
import {
  emptyError,
  ResponseType,
} from "../../../Types/ServicesType/servicesType";
import {
  billedItemResponseType,
  getbilledItemDetailsResponseType,
  getbilledItemPayloadType,
  paidListResponseType,
  PaymentData,
} from "./type";
import api from "@services/apiList";
import instance from "@services/services";

const { clinicId } = getConstants();
const { cashierApi } = api;

export const getBilledItemService = async (
  data: getbilledItemPayloadType,
): Promise<ResponseType<billedItemResponseType | null>> => {
  console.log(data);
  try {
    const result = await instance.post(cashierApi.getbilledPatients, {
      ...data,
      clinicId,
    });
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getPaidListService = async (
  data: getbilledItemPayloadType,
): Promise<ResponseType<paidListResponseType | null>> => {
  try {
    const result = await instance.post(cashierApi.getCashierbilldetails, {
      ...data,
      clinicId,
    });
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getBilledDetailsService = async (data: {
  billId: number;
}): Promise<ResponseType<getbilledItemDetailsResponseType | null>> => {
  try {
    const result = await instance.post(cashierApi.getbilledItemdetails, {
      ...data,
      clinicId,
    });
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const addPaymentService = async (
  data: PaymentData,
): Promise<ResponseType<any>> => {
  return (await instance.post(cashierApi.AddPayment, { ...data, clinicId }))
    .data;
};

export const getPrintService = async (
  id: number,
): Promise<ResponseType<any>> => {
  try {
    const result = await instance.get(
      `${cashierApi.getPrint}?cashierId=${id}&clinicId=${clinicId}`,
    );
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getPrintServicev2 = async (
  id: number,
): Promise<ResponseType<any>> => {
  try {
    const result = await instance.get(
      `${cashierApi.getPrintv2New}/${id}`,
    );
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const deleteCashierService = async (body: {
  cashierId: number;
  paymentId: number;
  userId: number;
  clinicId?: number;
}): Promise<ResponseType<any>> => {
  try {
    const result = await instance.post(`${cashierApi.delete}`, body);
    return result.data;
  } catch (error) {
    return emptyError;
  }
};
